import * as Api from '@ViewModels';
import moment from 'moment';
import { IUser } from '../../../extViewmodels';
import { formatOptional, formatUser } from '../../entities/utils/criteriaBuilder';
import { IPrizeLogFilter } from '../../models/slotMachines';
import {
	ILeaderboardDemosFilterCriteria,
	ILeaderboardFilterCriteria,
	LeaderboardDemosFilterCriteriaProperty,
	LeaderboardFilterCriteriaProperty,
} from '../../viewModels/gamification';

export interface ILeaderboardFilter {
	Manager?: IUser;
	OfficeLocation?: string;
	QuotaTeam?: string;
	Team?: string;
	User?: IUser;
	UserRole?: string;
	Vertical?: string;
}

export function leaderboardFilterToCriteria(filter: ILeaderboardFilter): ILeaderboardFilterCriteria[] {
	const criteria: ILeaderboardFilterCriteria[] = [];

	criteria.push(
		formatUser<LeaderboardFilterCriteriaProperty>(LeaderboardFilterCriteriaProperty.Manager, filter?.Manager)
	);
	criteria.push(
		formatOptional<LeaderboardFilterCriteriaProperty>(LeaderboardFilterCriteriaProperty.Team, filter?.Team)
	);

	criteria.push(formatUser<LeaderboardFilterCriteriaProperty>(LeaderboardFilterCriteriaProperty.User, filter?.User));
	criteria.push(
		formatOptional<LeaderboardFilterCriteriaProperty>(LeaderboardFilterCriteriaProperty.UserRole, filter?.UserRole)
	);
	criteria.push(
		formatOptional<LeaderboardFilterCriteriaProperty>(LeaderboardFilterCriteriaProperty.Vertical, filter?.Vertical)
	);
	criteria.push(
		formatOptional<LeaderboardFilterCriteriaProperty>(LeaderboardFilterCriteriaProperty.QuotaTeam, filter?.QuotaTeam)
	);
	criteria.push(
		formatOptional<LeaderboardFilterCriteriaProperty>(
			LeaderboardFilterCriteriaProperty.OfficeLocation,
			filter?.OfficeLocation
		)
	);

	return criteria.filter(item => !!item);
}

export type LeaderboardDemosGroupBy = 'Vertical' | 'QuotaTeam';

export interface ILeaderboardDemosFilter {
	day?: string;
	groupBy?: LeaderboardDemosGroupBy;
	officeLocation?: string;
}

export function leaderboardDemosFilterToCriteria(filter: ILeaderboardDemosFilter): ILeaderboardDemosFilterCriteria[] {
	const criteria: ILeaderboardDemosFilterCriteria[] = [];

	criteria.push(
		formatOptional<LeaderboardDemosFilterCriteriaProperty>(LeaderboardDemosFilterCriteriaProperty.Day, filter?.day)
	);
	criteria.push(
		formatOptional<LeaderboardDemosFilterCriteriaProperty>(
			LeaderboardDemosFilterCriteriaProperty.OfficeLocation,
			filter?.officeLocation
		)
	);

	return criteria.filter(item => !!item);
}

export const prizeLogFilterToGameTokenFilter = (filter: IPrizeLogFilter): Api.IGameTokenFilter => {
	const newFilter: Api.IGameTokenFilter = {
		criteria: [],
		op: Api.FilterOperator.And,
	};
	if (filter?.date) {
		newFilter.criteria.push({
			op: Api.FilterOperator.Gt,
			property: Api.GameTokenFilterCriteriaProperty.OutcomeDate,
			value: moment(filter?.date.start).startOf('day').format('YYYY-MM-DD'),
		});

		newFilter.criteria.push({
			op: Api.FilterOperator.Lt,
			property: Api.GameTokenFilterCriteriaProperty.OutcomeDate,
			value: moment(filter?.date.end).endOf('day').format('YYYY-MM-DD'),
		});
	}
	if (filter?.prizePaid) {
		newFilter.criteria.push({
			property: Api.GameTokenFilterCriteriaProperty.PrizePaid,
			value: 'false',
		});
	}
	if (filter?.user?.id) {
		newFilter.criteria.push({
			property: Api.GameTokenFilterCriteriaProperty.User,
			value: filter.user.id,
		});
	}
	return newFilter;
};
